import React from "react";
import { useTranslation } from "react-i18next";
import JoinTeamHeader from "./JoinTeamHeader";
import { StatusCard } from "./JoinLayout";

/** Sign-up for a player joining a team that isn't under-16. Not built yet. */
export default function PlayerSignup({ invite }) {
  const { t } = useTranslation();
  return (
    <StatusCard>
      <JoinTeamHeader invite={invite} />
      <p className="text-center text-[15px] leading-relaxed text-[#374151]">
        {t("auth.joinTeam.playerComingSoon")}
      </p>
    </StatusCard>
  );
}
